import PropTypes from 'prop-types';

export const pfaListItemType = {
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    legend: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired
};
